import { generateTableHtml, tableHtmlWrapper } from '@/utils/generate-html'

import {
  materialColumnTypeDict,
  materialTemplateDefineTypeDict
} from '@/dictionary/material/template'

import { getAllFilesByGroupIdApi } from '@/api/up-file'

import { strToThousands } from '@/utils/utils'
import { chunk } from 'lodash'

/**
 * 转换后台返回的基础字段模板，添加用于前端交互的字段
 */
export function setColumnConfig(defineList) {
  let columnConfig = []
  let nameConfig = {} // 品目名称字段
  let numConfig = {} // 采购量的模板配置
  let unitConfig = {} // 采购单位的模板配置
  let codeConfig = {} // 品目编码的模板配置
  let unitPriceConfig = {} // 预算单价的模板配置
  let modelConfig = {} // 参数型号的模板配置
  let controlPriceConfig = {} // 控制价
  columnConfig = (defineList || []).map(item => {
    return {
      columnName: item.columnName,
      // 字段类型为品目名称的或自定义的，均可以修改名称
      canEditColumnName:
        item.columnType === materialColumnTypeDict.NAME.value ||
        item.columnType === materialColumnTypeDict.CUSTOM.value,
      defineType: item.defineType,
      defineCode: item.defineCode,
      supplierRequire: item.supplierRequire,
      supplierVisible: item.supplierVisible,
      enable: item.isEnable === 1,
      isEnable: item.isEnable,
      columnType: item.columnType,
      // 字段类型为参数型号或自定义的，可以设置是否启用
      canEditEnable:
        item.columnType === materialColumnTypeDict.CUSTOM.value ||
        item.columnType === materialColumnTypeDict.MODEL.value
    }
  })

  nameConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.NAME.value
    ) || {}

  codeConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.CODE.value
    ) || {}

  numConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.NUM.value
    ) || {}

  unitConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.UNIT.value
    ) || {}

  unitPriceConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.UNIT_PRICE.value
    ) || {}

  modelConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.MODEL.value
    ) || {}

  controlPriceConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.CONTROL_PRICE.value
    ) || {}
  if (controlPriceConfig.columnName) {
    controlPriceConfig.columnName = controlPriceConfig.columnName.replace(
      '（元）',
      ''
    )
  }

  return {
    columnConfig,
    nameConfig,
    codeConfig,
    numConfig,
    unitConfig,
    unitPriceConfig,
    modelConfig,
    controlPriceConfig
  }
}

/**
 * 设定用于表格展示的相应信息模板
 */
export function setTableConfig(columnConfig) {
  const materielInfoConfig = []
  const purchaseSpecifyConfig = []
  const supplierResponseConfig = []
  columnConfig.forEach(item => {
    // 获取品目名称和品目编码的字段配置
    if (
      item.columnType === materialColumnTypeDict.NAME.value ||
      item.columnType === materialColumnTypeDict.CODE.value
    ) {
      materielInfoConfig.push(item)
    }
    // 获取供应商响应且已启用的字段配置
    if (
      item.defineType === materialTemplateDefineTypeDict.RESPONSE.value &&
      item.isEnable
    ) {
      supplierResponseConfig.push(item)
    }
    // 获取采购人指定且已启用的字段配置
    if (
      item.defineType === materialTemplateDefineTypeDict.SPECIFY.value &&
      item.isEnable
    ) {
      purchaseSpecifyConfig.push(item)
    }
  })

  // 由于模板中不存在分类的定义，需要手动添加分类
  materielInfoConfig.push({
    defineCode: 'categoryId',
    columnName: '分类'
  })
  return {
    materielInfoConfig,
    purchaseSpecifyConfig,
    supplierResponseConfig
  }
}

/**
 * 获取品目列表
 */
export async function getMaterielHtmlData({
  materielList = [],
  isDollar = false,
  materielInfoConfig = {},
  purchaseSpecifyConfig = {},
  supplierResponseConfig = {},
  numConfig = {},
  unitConfig = {},
  modelConfig = {},
  controlPriceConfig = {}
}) {
  const materielListGroupIds =
    materielList.map(el => el.attachmentGroupId).join(',') || ''

  const groupIdObj = {}
  if (materielListGroupIds && materielListGroupIds != 0) {
    const { data } = await getAllFilesByGroupIdApi(materielListGroupIds)
    data.forEach(el => {
      groupIdObj[el.groupId] = el.attachmentInfo.fileName
    })
  }

  const materieltableHeader = [
    { content: '序号', width: '20px' },
    { content: '品目信息', width: '120px' },
    { content: '采购量/计量单位', width: '100px' },
    modelConfig.isEnable ? { content: '参数型号', width: '60px' } : undefined,
    { content: `预算单价(${isDollar ? '美元' : '元'})`, width: '60px' },
    { content: `总价(${isDollar ? '美元' : '元'})`, width: '60px' },
    controlPriceConfig.isEnable
      ? {
        content: `${controlPriceConfig.columnName}(${
          isDollar ? '美元' : '元'
        })`,
        width: '60px'
      }
      : undefined,
    { content: '对供应商备注', width: '100px' },
    { content: '内部备注', width: '100px' },
    { content: '附件' },
    { content: '采购人指定', width: '140px' },
    { content: '供应商响应', width: '140px' }
  ].filter(value => value)
  const materieltableBody = materielList.map((value, index) => {
    return [
      { content: index + 1 },
      {
        content: materielInfoConfig.map(m => {
          return `${m.columnName}：${value[m.defineCode] || '-'}`
        }),
        style: 'text-align: left;'
      },
      {
        content:
          (value[numConfig.defineCode] || '-') +
          '/' +
          (value[unitConfig.defineCode] || '-')
      },
      modelConfig.isEnable
        ? {
          content: value[modelConfig.defineCode] || '-'
        }
        : undefined,
      {
        content: strToThousands(value.budgetUnitPrice) || '-'
      },
      { content: strToThousands(value.totalPrice) || '-' },
      controlPriceConfig.isEnable
        ? {
          content: strToThousands(value[controlPriceConfig.defineCode]) || '-'
        }
        : undefined,
      { content: value.remarks || '-' },
      { content: value.insideRemark || '-' },
      { content: groupIdObj[value.attachmentGroupId] || '-' },
      {
        content: purchaseSpecifyConfig.map(p => {
          return `${p.columnName}：${value[p.defineCode] || '-'}`
        }),
        style: 'text-align: left;'
      },
      {
        content: supplierResponseConfig.map(s => {
          return `${s.columnName}：无需填写`
        }),
        style: 'text-align: left;'
      }
    ].filter(value => value)
  })
  return {
    materieltableHeader,
    materieltableBody
  }
}

/**
 *
 * @param {*} pdfData
 * @returns
 */
export async function generateMaterielOfferHtml({
  pdfData = {},
  pdfTitle = '',
  isDollar = false,
  requireTax = false
}) {
  const yellowStyle = 'color: #faad14;'
  const greenStyle = 'color: green;'
  const redStyle = 'color: red;'
  const fontWeight = 'font-weight: bold;'
  const font18Style = 'font-size: 18px;'

  const {
    columnConfig,
    nameConfig,
    codeConfig,
    numConfig,
    unitConfig,
    unitPriceConfig,
    modelConfig,
    controlPriceConfig
  } = setColumnConfig(pdfData.itemSchemaList || [])
  const { purchaseSpecifyConfig, supplierResponseConfig } = setTableConfig(
    columnConfig
  )

  // 轮次报价
  const supplierTableHeader = [
    { content: '序号', width: '20px' },
    { content: '供应商名称' },
    { content: `报价总金额(${isDollar ? '美元' : '元'})`, width: '70px' },
    { content: '报价轮次', width: '40px' },
    { content: `未含税价(${isDollar ? '美元' : '元'})`, width: '60px' },
    { content: '税率(%)', width: '40px' },
    { content: `含税价(${isDollar ? '美元' : '元'})`, width: '50px' },
    { content: '供应商响应', width: '200px' }
  ]
  // 报价汇总表
  const supplierSumHeader = [
    { content: '序号', width: '40px', style: font18Style },
    { content: '供应商名称', style: font18Style },
    requireTax
      ? {
        content: `含税总价（${isDollar ? '美元' : '元'}）`,
        style: font18Style
      }
      : undefined,
    requireTax
      ? {
        content: `非含税总价（${isDollar ? '美元' : '元'}）`,
        style: font18Style
      }
      : undefined,
    !requireTax
      ? {
        content: `报价总金额（${isDollar ? '美元' : '元'}）`,
        style: font18Style
      }
      : undefined
  ].filter(value => value)
  let allRoundHtml = ''
  // 每轮报价
  for (let i = 0; i < pdfData.roundCompareList.length; i++) {
    const value = pdfData.roundCompareList[i]
    let itemRoundHtml = ''
    const materielListGroupIds =
      value.itemCompareList
        .map(el => el.materiel.attachmentGroupId)
        .join(',') || ''
    const groupIdObj = {}
    if (materielListGroupIds && materielListGroupIds != 0) {
      const { data } = await getAllFilesByGroupIdApi(materielListGroupIds)
      data.forEach(el => {
        groupIdObj[el.groupId] = el.attachmentInfo.fileName
      })
    }

    // 供应商报价汇总
    const supplierSumBody = (value.allOfferList || []).map((el, sumIndex) => {
      return [
        { content: sumIndex + 1, style: font18Style },
        { content: el.supplierName, style: font18Style },
        requireTax
          ? { content: el.offerAmount, style: font18Style }
          : undefined,
        requireTax
          ? { content: el.noRateOfferAmount, style: font18Style }
          : undefined,
        !requireTax
          ? { content: el.offerAmount, style: font18Style }
          : undefined
      ].filter(value => value)
    })
    const supplierSumHtml = generateTableHtml({
      pdfTitle: pdfTitle,
      describeInfoTop: [
        [
          { label: '询比单名称', content: pdfData.orderName },
          { label: '项目估算(万元)', content: pdfData.budgetAmount },
          {
            label: '项目负责人',
            content: `${pdfData.releaserEmpName} ${pdfData.releaserMobile}`
          }
        ],
        [
          {
            label: '',
            content: '供应商报价汇总表',
            style: fontWeight + font18Style
          }
        ]
      ],
      tableHead: { dynamic: supplierSumHeader },
      tableData: supplierSumBody,
      needHtmlWrapper: false,
      needPageWrapper: true
    })
    allRoundHtml += getTopQrcodeHtml(pdfData)

    allRoundHtml += supplierSumHtml
    // 供应商报价
    value.itemCompareList.forEach((materialLatestOfferItem, materialIndex) => {
      const materielInfo = materialLatestOfferItem.materiel || {}
      const supplierCompareList =
        materialLatestOfferItem.supplierCompareList || []
      const supplierTableBody = supplierCompareList.map(
        (materielOfferDetailItem, materielOfferDetailItemIndex) => {
          let offerTotalPriceStyle = ''
          if (materielOfferDetailItem.offerTotalPriceHigh) {
            offerTotalPriceStyle = redStyle
          }
          if (materielOfferDetailItem.offerTotalPriceLow) {
            offerTotalPriceStyle = greenStyle
          }
          let noTaxRateOfferStyle = ''
          if (materielOfferDetailItem.noTaxRateOfferHigh) {
            noTaxRateOfferStyle = redStyle
          }
          if (materielOfferDetailItem.noTaxRateOfferLow) {
            noTaxRateOfferStyle = greenStyle
          }
          let offerPriceStyle = ''
          if (materielOfferDetailItem.offerPriceHigh) {
            offerPriceStyle = redStyle
          }
          if (materielOfferDetailItem.offerPriceLow) {
            offerPriceStyle = greenStyle
          }
          return [
            {
              content: materielOfferDetailItemIndex + 1
            },
            {
              content: materielOfferDetailItem.supplierName || '-'
            },
            {
              content:
                strToThousands(materielOfferDetailItem.offerTotalPrice) || '-',
              style: offerTotalPriceStyle
            },
            {
              content: materielOfferDetailItem.roundName || '-',
              style: materielOfferDetailItem.currentRound ? '' : yellowStyle
            },
            {
              content:
                strToThousands(
                  requireTax
                    ? materielOfferDetailItem.noTaxRateOffer
                    : materielOfferDetailItem.offerPrice
                ) || '-',
              style: noTaxRateOfferStyle
            },
            {
              content: materielOfferDetailItem.offerTaxRate || '-'
            },
            {
              content:
                strToThousands(materielOfferDetailItem.offerPrice) || '-',
              style: offerPriceStyle
            },
            {
              content: supplierResponseConfig.map(s => {
                return `${s.columnName}：${materielOfferDetailItem[
                  s.defineCode
                ] || '-'}`
              }),
              style: 'text-align: left;'
            }
          ].filter(value => value)
        }
      )

      // 单个品目信息
      const materielItemTableHtml = generateTableHtml({
        pdfTitle: pdfTitle,
        describeInfoTop: [
          [
            {
              label: '',
              content: `${value.roundName}信息`,
              style: fontWeight
            },
            {
              label: '报价截止时间',
              content: value.offerEndTime,
              style: fontWeight
            }
          ]
        ],
        tableData: chunk(
          [
            { content: '品目序号', style: 'font-weight: bold' },
            { content: Number(materialIndex) + 1 },
            {
              content: nameConfig.columnName,
              style: 'font-weight: bold'
            },
            { content: materielInfo[nameConfig.defineCode] },
            {
              content: codeConfig.columnName,
              style: 'font-weight: bold'
            },
            { content: materielInfo[codeConfig.defineCode] },
            { content: '分类', style: 'font-weight: bold' },
            {
              content: `${(materielInfo.categoryNameTree || []).join('>') ||
                '-'}`
            },
            { content: '采购量/计量单位', style: 'font-weight: bold' },
            {
              content:
                (materielInfo[numConfig.defineCode] || '-') +
                '/' +
                (materielInfo[unitConfig.defineCode] || '-')
            },
            modelConfig.isEnable
              ? {
                content: modelConfig.columnName,
                style: 'font-weight: bold'
              }
              : undefined,
            modelConfig.isEnable
              ? { content: materielInfo[modelConfig.defineCode] }
              : undefined,
            {
              content: unitPriceConfig.columnName,
              style: 'font-weight: bold'
            },
            {
              content: strToThousands(
                materielInfo[unitPriceConfig.defineCode] || ''
              )
            },
            {
              content: `预算总价(${isDollar ? '美元' : '元'})`,
              style: 'font-weight: bold'
            },
            { content: strToThousands(materielInfo.totalPrice) || '' },
            controlPriceConfig.isEnable
              ? {
                content: `${controlPriceConfig.columnName}(${
                  isDollar ? '美元' : '元'
                })`,
                style: 'font-weight: bold'
              }
              : undefined,
            controlPriceConfig.isEnable
              ? {
                content:
                    strToThousands(
                      materielInfo[controlPriceConfig.defineCode]
                    ) || ''
              }
              : undefined,
            ...purchaseSpecifyConfig
              .map(p => {
                return [
                  { content: p.columnName, style: 'font-weight: bold' },
                  { content: materielInfo[p.defineCode] }
                ]
              })
              .flat(),
            { content: '内部备注', style: 'font-weight: bold' },
            { content: materielInfo.insideRemark || '' },
            { content: '对供应商备注', style: 'font-weight: bold' },
            { content: materielInfo.remarks || '' },
            { content: '附件', style: 'font-weight: bold' },
            { content: groupIdObj[materielInfo.attachmentGroupId] || '' }
          ].filter(value => value),
          6
        ),
        needHtmlWrapper: false,
        needPageWrapper: false
      })
      // 供应商报价
      const supplierTableHtml = generateTableHtml({
        pdfTitle: '',
        describeInfoTop: [
          [{ label: '', content: '报价供应商', style: fontWeight }]
        ],
        tableHead: { dynamic: supplierTableHeader },
        tableData: supplierTableBody,
        needHtmlWrapper: false,
        needPageWrapper: false
      })
      itemRoundHtml +=
        materielItemTableHtml +
        supplierTableHtml +
        '<div style="page-break-after: always;"></div>'
    })
    allRoundHtml += itemRoundHtml

    allRoundHtml += getBottomQrcodeHtml(pdfData)
  }

  const tableHtml = tableHtmlWrapper(allRoundHtml, pdfTitle)
  return tableHtml
}

// 顶部二维码
function getTopQrcodeHtml(Info) {
  if (Info.isArchivist) {
    return `
    <table
        cellspaacing="0"
        cellpadding="0"
        style="width: 100%;"
      >
      <tr>
        <td>
          <div style="font-size: 16px; font-weight: bold; float: right; text-align: center;">
            <img src="${Info.qrCodeUrl}" alt="" style="width: 80px;"></img>
            <div>扫一扫核验项目真伪</div>
          </div>
        </td> 
      </tr>
    </table> 
    `
  } else {
    return ''
  }
}

// 底部二维码
function getBottomQrcodeHtml(Info) {
  if (Info.isArchivist) {
    return `
      <table
        cellspaacing="0"
        cellpadding="0"
      >
      <tr>
        <td>
          <div style="font-size: 16px; font-weight: bold; float: left; text-align: center;">
            <img src="${Info.qrCodeUrl}" alt="" style="width: 80px;"></img>
            <div>扫一扫核验项目真伪</div>
          </div>
        </td>
      </tr>
      </table>
    `
  } else {
    return ''
  }
}

/**
 * 获取品目列表
 */
export function getCandidateCancelHtmlData({
  cancelList = [],
  isDollar = false,
  materielInfoConfig = {},
  purchaseSpecifyConfig = {},
  numConfig = {},
  unitConfig = {}
}) {
  const materieltableHeader = [
    { content: '序号', width: '20px' },
    { content: '品目信息', width: '200px' },
    { content: '采购量/单位', width: '60px' },
    { content: `预算单价(${isDollar ? '美元' : '元'})`, width: '60px' },
    { content: `预算总价(${isDollar ? '美元' : '元'})`, width: '60px' },
    { content: '采购人指定', width: '200px' },
    { content: '报价供应商数量', width: '200px' }
  ]
  const materieltableBody = cancelList.map((value, index) => {
    return [
      { content: index + 1 },
      {
        content: materielInfoConfig.map(m => {
          return `${m.columnName}：${value[m.defineCode] || '-'}`
        }),
        style: 'text-align: left;'
      },
      {
        content:
          (value[numConfig.defineCode] || '-') +
          '/' +
          (value[unitConfig.defineCode] || '-')
      },
      {
        content: strToThousands(value.budgetUnitPrice) || '-'
      },
      { content: strToThousands(value.totalPrice) || '-' },
      {
        content: purchaseSpecifyConfig.map(p => {
          return `${p.columnName}：${value[p.defineCode] || '-'}`
        }),
        style: 'text-align: left;'
      },
      {
        content: value.supplierNum || 0,
        style: 'text-align: left;'
      }
    ].filter(value => value)
  })
  return {
    materieltableHeader,
    materieltableBody
  }
}
